import React, { useState } from 'react';
import { DownloadIcon, CalendarIcon } from 'lucide-react';
import { MetricCard } from '../components/MetricCard';
import { LineChart } from '../components/charts/LineChart';
import { ResourceUtilization } from '../components/ResourceUtilization';
import { DateSelector } from '../components/DateSelector';
export const SystemHealth: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const timeRanges = ['12 months', '3 months', '30 days', '7 days', 'Today'];
  const responseTimeData = Array.from({
    length: 12
  }, (_, i) => ({
    month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i],
    value: 40 + Math.random() * 50
  }));
  const errorRateData = Array.from({
    length: 12
  }, (_, i) => ({
    month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][i],
    value: 55 + Math.random() * 20
  }));
  return <div data-id="element-565">
      <div className="flex justify-between items-center mb-6" data-id="element-566">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-567">System Health</h2>
        <button className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-md text-sm" data-id="element-568">
          <DownloadIcon size={16} className="mr-2" data-id="element-569" />
          Download report
        </button>
      </div>
      <div className="mb-6" data-id="element-570">
        <div className="flex space-x-4 mb-6" data-id="element-571">
          {timeRanges.map(range => <button key={range} className={`px-4 py-2 text-sm rounded-md ${range === '30 days' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-572">
              {range}
            </button>)}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-573">
        <MetricCard title="System Uptime" value="99.97%" change={{
        value: '+0.03%',
        positive: true
      }} data-id="element-574" />
        <MetricCard title="Avg. Response Time" value="238ms" change={{
        value: '+2ms',
        positive: false
      }} data-id="element-575" />
        <MetricCard title="Error Rate" value="0.04%" change={{
        value: '-2pts',
        positive: true
      }} data-id="element-576" />
        <MetricCard title="Active Sessions" value="42,856" change={{
        value: '+42ms',
        positive: true
      }} data-id="element-577" />
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-578">
        <div className="flex justify-between items-center mb-6" data-id="element-579">
          <h3 className="text-lg font-medium" data-id="element-580">Response Time Trends</h3>
          <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm" data-id="element-581">
            Download Report
          </button>
        </div>
        <div className="mb-4" data-id="element-582">
          <div className="flex space-x-4" data-id="element-583">
            {timeRanges.map(range => <button key={range} className={`px-4 py-1.5 text-sm rounded-md ${range === '30 days' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-584">
                {range}
              </button>)}
          </div>
        </div>
        <LineChart data={responseTimeData} xKey="month" yKey="value" data-id="element-585" />
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-586">
        <div className="flex justify-between items-center mb-6" data-id="element-587">
          <h3 className="text-lg font-medium" data-id="element-588">Error Rate Trends</h3>
          <button className="text-blue-600 bg-white border border-gray-200 px-4 py-1.5 rounded-md text-sm" data-id="element-589">
            Download Report
          </button>
        </div>
        <div className="mb-4" data-id="element-590">
          <div className="flex space-x-4" data-id="element-591">
            {timeRanges.map(range => <button key={range} className={`px-4 py-1.5 text-sm rounded-md ${range === '30 days' ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-592">
                {range}
              </button>)}
          </div>
        </div>
        <LineChart data={errorRateData} xKey="month" yKey="value" data-id="element-593" />
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-594">
        <div className="flex justify-between items-center mb-6" data-id="element-595">
          <h3 className="text-lg font-medium" data-id="element-596">Resource Utilization</h3>
          <DateSelector selectedDate={selectedDate} onDateChange={setSelectedDate} data-id="element-597" />
        </div>
        <ResourceUtilization label="CPU" percentage={68} color="bg-green-500" data-id="element-598" />
        <ResourceUtilization label="Memory" percentage={72} color="bg-orange-500" data-id="element-599" />
        <ResourceUtilization label="Storage" percentage={45} color="bg-green-500" data-id="element-600" />
        <ResourceUtilization label="Network" percentage={34} color="bg-green-500" data-id="element-601" />
      </div>
    </div>;
};